import React, { Component } from 'react';
import Modal from 'react-modal';
import InvoiceItemUpdateModalUI from './InvoiceItemUpdateModalUI';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import { withRouter } from 'react-router-dom';

class InvoiceItemUpdateModalSF extends Component {
	constructor(props) {
		super(props);
		this.state = {
			successMsg: null,
			errorList: null,
			submitted: false,
			productItemId: '',
			productItemIdError: null,
			quantity: '',
			quantityError: null,
		};
	}

	render() {
		return (
			<InvoiceItemUpdateModalUI
				context={this.props.context}
				errorList={this.state.errorList}
				successMsg={this.state.successMsg}
				setErrorList={this.setErrorList}

				invoiceItemUpdateMode={this.props.invoiceItemUpdateMode}
				submitted={this.state.submitted}

				onSubmit={this.onSubmit}
				onCancelClick={this.onCancelClick}

				productItemId={this.state.productItemId}
				onProductItemIdChange={(event) => { this.setState({ productItemId: event.target.value }) }}
				productItemIdError={this.state.productItemIdError}
				setProductItemIdError={(error) => { this.setState({ productItemIdError: error }) }}

				quantity={this.state.quantity}
				onQuantityChange={(event) => { this.setState({ quantity: event.target.value }) }}
				quantityError={this.state.quantityError}
				setQuantityError={(error) => { this.setState({ quantityError: error }) }}
			/>
		);
	}

	onCancelClick = () => {
		this.setState({
			submitted: false,
			errorList: null,
		});
		this.props.onCancelClick();
	}

	componentDidMount() {
		Modal.setAppElement('body');
	}

	componentDidUpdate(prevProps) {
		const { selectedInvoice } = this.props;
		if (selectedInvoice && (!prevProps.selectedInvoice || prevProps.selectedInvoice.customerInvoiceId !== selectedInvoice.customerInvoiceId)) {
			this.setState({
				productItemId: selectedInvoice.productItemId,
				quantity: selectedInvoice.quantity,
			});
		}
	}

	onSubmit = () => {
		if (this.state.submitted) return;

		this.setState({
			successMsg: null,
			errorList: [],
			submitted: true,
		});

		const { productItemId, quantity } = this.state;

		RestApiUtils.put(
			this.props.context,
			`/api/su/accounts/${this.props.account.accountId}/invoices/${this.props.selectedInvoice.customerInvoiceId}/invoiceItems/productItems/${productItemId}`,
			this.onSubmitCallback,
			{
				quantity: this.state.quantity,
				productItemId: this.state.productItemId
			}
		);
	}

	onSubmitCallback = (response) => {
		let errorList = [];
		if (response.errorList) {
			response.errorList.forEach(error => {
				errorList.push(error.message);
			});
		}

		this.setState({
			successMsg: response.success,
			errorList: errorList,
			submitted: false,
		});

		if (errorList.length === 0) {
			setTimeout(() => {
				this.setState({ successMsg: null });
				this.props.onCancelClick();
				this.props.onRefreshClick();
			}, 1000);
		}
	}

	setErrorList = (errorList) => {
		this.setState({ errorList });
	}
}

export default withRouter(InvoiceItemUpdateModalSF);
